<template>
  <div>
    <h1 class="page-header">Card Profile</h1>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-6">
            <ts-button color="info" outline @click="$router.push({ name: 'card-profile-create' })">
              Add New
            </ts-button>
          </div>
          <div class="col-sm-6 d-flex justify-content-end">
            <ts-input v-model="search" placeholder="Search" style="width: 300px;" />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template slot-scope="{ record }">
          <td>{{ record.customer.name }}</td>
          <td>{{ record.serial_card }}</td>
          <td>{{ record.card_type.type }}</td>
          <td>{{ record.effective_date }}</td>
          <td>{{ record.expiry_date }}</td>
          <td>
            <span v-if="model.card_id != record.card_id">{{ record.card_status.status }}</span>
            <select v-model="model.card_status_id" class="form-control" v-if="model.card_id == record.card_id">
              <option
                v-for="(card, index) in cardStatus"
                :key="index"
                :value="card.card_status_id"
                :disabled="record.card_status_id == card.card_status_id"
                >{{ card.card_status }}</option
              >
            </select>
          </td>
          <td>
            <span v-if="model.card_id != record.card_id">{{ record.status_reason }}</span>
            <textarea
              rows="1"
              class="form-control"
              :class="{ 'is-invalid': errors.has('status_reason') }"
              v-model="model.status_reason"
              v-if="model.card_id == record.card_id"
            ></textarea>
          </td>
          <td>{{ record.activated_date }}</td>
          <td class="text-center">
            <ts-button
              v-if="model.card_id == record.card_id"
              class="btn-xs btn-primary mr-2"
              @click="statusChange(record)"
            >
              <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
              <i class="fa fa-save" v-else></i>
            </ts-button>
            <ts-button @click="cancel" v-if="model.card_id == record.card_id" class="btn-xs btn-default">
              <i class="fa fa-times"></i>
            </ts-button>
            <a
              href="#"
              title="change status"
              class="text-info mr-2"
              v-if="model.card_id != record.card_id"
              @click.prevent="changStatus(record)"
            >
              <i class="fas fa-random"></i>
            </a>
            <a
              href="#"
              title="edit"
              class="text-primary mr-2"
              v-if="model.card_id != record.card_id"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
          </td>
        </template>
      </ts-table>
      <ts-card-wrapper class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData"> </ts-pagination>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'card-profile',
  data() {
    return {
      loading: false,
      columns: [
        { name: 'customer name', style: 'width: 14.5%' },
        { name: 'serial', sortKey: 'card_number', style: 'width: 12%' },
        { name: 'type', sortKey: 'card_type.type', style: 'width: 8%' },
        { name: 'effectiv', sortKey: 'card_number', style: 'width: 10%' },
        { name: 'expired', sortKey: 'card_number', style: 'width: 10%' },
        { name: 'status', style: 'width: 8%' },
        { name: 'reason' },
        { name: 'activated', style: 'width: 11%' },
        { name: 'Action', style: 'width: 7%; text-align:center' }
      ],
      model: {
        card_id: '',
        card_status_id: '',
        status_reason: ''
      },
      errors: new Errors()
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('administration/cardProfile', ['resources', 'pagination', 'cardStatus']),
    search: {
      get() {
        return this.$store.state.administration.cardProfile.search
      },
      set(newValue) {
        this.$store.commit('administration/cardProfile/SET_SEARCH', newValue)
        this.$store.commit('administration/cardProfile/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('administration/cardProfile/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.$store.commit('administration/cardProfile/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'card-profile-edit',
        params: { id: record.card_id }
      })
    },
    changStatus(record) {
      this.model.card_id = record.card_id
      this.model.card_status_id = record.card_status_id
      this.model.status_reason = record.status_reason
    },
    statusChange(record) {
      record._deleting = true
      this.$store
        .dispatch('administration/cardProfile/statusChange', this.model)
        .then(response => {
          record._deleting = false
          this.$toasted.success(response.message)
          this.cancel()
          this.fetchData()
        })
        .catch(error => {
          record._deleting = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },
    cancel() {
      this.model = {
        card_id: '',
        card_status_id: '',
        status_reason: ''
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('administration/cardProfile/RESET_STATE')
    }
    next()
  }
}
</script>
<style lang="css" scoped>
table td {
	vertical-align : middle;
}
</style>
